function viewportHasMethod(viewport, method) {
    return (typeof viewport?.[method] ===
        'function');
}
export function viewportSupportsImageSlices(viewport) {
    return (viewportHasMethod(viewport, 'getCurrentImageId') &&
        viewportHasMethod(viewport, 'getCurrentImageIdIndex') &&
        viewportHasMethod(viewport, 'getImageIds') &&
        viewportHasMethod(viewport, 'hasImageURI'));
}
export function viewportSupportsStackCompatibility(viewport) {
    return (viewportSupportsImageSlices(viewport) &&
        viewportHasMethod(viewport, 'setStack'));
}
export function viewportSupportsStackCalibration(viewport) {
    return (viewportSupportsImageSlices(viewport) &&
        viewportHasMethod(viewport, 'calibrateSpacing'));
}
export function viewportSupportsVolumeCompatibility(viewport) {
    return (viewportHasMethod(viewport, 'addVolumes') &&
        viewportHasMethod(viewport, 'setVolumes'));
}
export function viewportSupportsVolumeId(viewport) {
    return viewportHasMethod(viewport, 'hasVolumeId');
}
export function viewportSupportsVolumeURI(viewport) {
    return viewportHasMethod(viewport, 'hasVolumeURI');
}
export function viewportSupportsVolumeActors(viewport) {
    return (viewportSupportsVolumeId(viewport) &&
        viewportHasMethod(viewport, 'getActors'));
}
